import React from "react"
import { Container } from "./style"
import { useAuth } from "../../hooks/useAuth"

export const PersonDisplayCard = () => {
   const { user, authenticated, logout } = useAuth()

   if (authenticated === null) {
      return (
         <Container>
            <span>Carregando...</span>
         </Container>
      )
   }

   if (!user) {
      return null
   }

   return (
      <Container>
         <span>{user.displayName}</span>
         <div>{/* <img src={user.photoURL} alt={user.displayName} /> */}</div>
         <button onClick={logout} style={{ marginLeft: "1rem", cursor: "pointer", padding: "0 0.5rem" }}>
            Sair
         </button>
      </Container>
   )
}
